import { Stack } from "@mui/material";
import React from "react";
import DoubleChart from "./DoubleChart";
import CustomKPI from "./CustomKPI";

import { blue, orange } from "@mui/material/colors";
import CustomBarChart from "./CustomBarChart";

import CustomPieChart from "./CustomPieChart";
import CustomMetricsTable from "./CustomMetricsTable";

function SummaryDashboard({ autoSummary, fireSummary, totalNumClaims }) {
  function rollupDocCodes(data) {
    const combined = {};

    data.forEach(({ docCode, count }) => {
      // Split code
      const [left, right] = docCode.split(" - ");
      // Create canonical key (alphabetically first)
      const canonical = [left, right].sort().join(" - ");

      // Roll up
      if (combined[canonical]) {
        combined[canonical] += count;
      } else {
        combined[canonical] = count;
      }
    });

    // Return as an array of objects
    return Object.entries(combined).map(([docCode, count]) => ({
      docCode,
      count,
    }));
  }

  const totalAutoDocs = 30426;
  const totalFireDocs = 12825;
  // const totalNumClaims = 900;

  return (
    <Stack
      sx={{
        border: 0,
        p: 1,
        display: "flex",
        justifyContent: "center",
        overflowX: "auto",
      }}
      spacing={1}
    >
      <CustomMetricsTable
        fireSummary={fireSummary}
        autoSummary={autoSummary}
        totalAutoDocs={totalAutoDocs}
        totalFireDocs={totalFireDocs}
        totalNumClaims={totalNumClaims}
      />
       {/* <Stack
        spacing={1}
        direction={"row"}
        sx={{
          justifyContent: "center",
          width: "100%",
          display: "flex",
          border: 0,
        }}
      >
        <DoubleChart
          maxWidth={400}
          minWidth={210}
          title={"AVG timespan of Claim"}
          chart1={
            <CustomKPI
              title={"Auto"}
              value={autoSummary.avg_claim_timespan.toFixed(1)}
              text_below={"Days"}
              chip_color="background.main"
              text_color={blue[900]}
              value_color={blue[900]}
            />
          }
          chart2={
            <CustomKPI
              title={"Fire"}
              value={fireSummary.avg_claim_timespan.toFixed(1)}
              text_below={"Days"}
              chip_color={"background.main"}
              text_color={orange[900]}
              value_color={orange[900]}
            />
          }
        />
        <DoubleChart
          maxWidth={500}
          minWidth={310}
          title={"Total Number of Qualifying Comparisons"}
          chart1={
            <CustomKPI
              title={"Auto"}
              value={autoSummary.sum_qualifying_comparisons.toLocaleString()}
              text_below={"Docs"}
              chip_color="background.main"
              text_color={blue[900]}
              value_color={blue[900]}
            />
          }
          chart2={
            <CustomKPI
              title={"Fire"}
              value={fireSummary.sum_qualifying_comparisons.toLocaleString()}
              text_below={"Docs"}
              chip_color={"background.main"}
              text_color={orange[900]}
              value_color={orange[900]}
            />
          }
        />
        <DoubleChart
          maxWidth={500}
          minWidth={310}
          title={"AVG Number of Qualifying Comparisons per Claim"}
          chart1={
            <CustomKPI
              title={"Auto"}
              value={autoSummary.avg_qualifying_comparisons.toFixed(1)}
              text_below={"Docs/Claim"}
              chip_color="background.main"
              text_color={blue[900]}
              value_color={blue[900]}
            />
          }
          chart2={
            <CustomKPI
              title={"Fire"}
              value={fireSummary.avg_qualifying_comparisons.toFixed(1)}
              text_below={"Docs/Claim"}
              chip_color={"background.main"}
              text_color={orange[900]}
              value_color={orange[900]}
            />
          }
        />
      </Stack> */}
     <Stack
        spacing={1}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/*  <Stack
          spacing={1}
          direction={"row"}
          sx={{
            justifyContent: "center",
            width: "100%",
            display: "flex",
            border: 0,
          }}
        >
          <DoubleChart
            maxWidth={500}
            minWidth={350}
            title={"Total Similar Comparisons generated for all Claims"}
            chart1={
              <CustomKPI
                title={"Auto"}
                value={autoSummary.sum_claim_doc_pairs.toLocaleString()}
                text_below={"Similar Comparisons"}
                chip_color="background.main"
                text_color={blue[900]}
                value_color={blue[900]}
              />
            }
            chart2={
              <CustomKPI
                title={"Fire"}
                value={fireSummary.sum_claim_doc_pairs.toLocaleString()}
                text_below={"Similar Comparisons"}
                chip_color={"background.main"}
                text_color={orange[900]}
                value_color={orange[900]}
              />
            }
          />
          <DoubleChart
            maxWidth={500}
            minWidth={300}
            title={"AVG Number of Similar Comparisons per Claim"}
            chart1={
              <CustomKPI
                title={"Auto"}
                value={autoSummary.avg_claim_doc_pairs.toFixed(1)}
                text_below={"Similar Comparisons"}
                chip_color="background.main"
                text_color={blue[900]}
                value_color={blue[900]}
              />
            }
            chart2={
              <CustomKPI
                title={"Fire"}
                value={fireSummary.avg_claim_doc_pairs.toFixed(1)}
                text_below={"Similar Comparisons"}
                chip_color={"background.main"}
                text_color={orange[900]}
                value_color={orange[900]}
              />
            }
          />

          <DoubleChart
            maxWidth={500}
            minWidth={300}
            title={"AVG Number of Pages per Similar Comparison"}
            chart1={
              <CustomKPI
                title={"Auto"}
                value={autoSummary.avg_num_pages_per_pair.toFixed(1)}
                text_below={"Pages"}
                chip_color="background.main"
                text_color={blue[900]}
                value_color={blue[900]}
              />
            }
            chart2={
              <CustomKPI
                title={"Fire"}
                value={fireSummary.avg_num_pages_per_pair.toFixed(1)}
                text_below={"Pages"}
                chip_color={"background.main"}
                text_color={orange[900]}
                value_color={orange[900]}
              />
            }
          />
        </Stack>
        <Stack
          spacing={1}
          direction={"row"}
          sx={{
            justifyContent: "center",
            width: "100%",
            display: "flex",
            border: 0,
          }}
        >
          <DoubleChart
            maxWidth={500}
            minWidth={300}
            title={"Total Number of Docs for all Claims"}
            chart1={
              <CustomKPI
                title={"Auto"}
                value={totalAutoDocs.toLocaleString()}
                text_below={"Docs"}
                chip_color="background.main"
                text_color={blue[900]}
                value_color={blue[900]}
              />
            }
            chart2={
              <CustomKPI
                title={"Fire"}
                value={totalFireDocs.toLocaleString()}
                text_below={"Docs"}
                chip_color={"background.main"}
                text_color={orange[900]}
                value_color={orange[900]}
              />
            }
          />
          <DoubleChart
            maxWidth={500}
            minWidth={350}
            title={"Overall % of Docs that generate a Similar Comparison"}
            chart1={
              <CustomKPI
                title={"Auto"}
                value={
                  (
                    (autoSummary.sum_claim_doc_pairs / totalAutoDocs) *
                    100
                  ).toFixed(3) + "%"
                }
                text_below={
                  "(" +
                  autoSummary.sum_claim_doc_pairs +
                  " out of " +
                  totalAutoDocs.toLocaleString() +
                  ")"
                }
                chip_color="background.main"
                text_color={blue[900]}
                value_color={blue[900]}
              />
            }
            chart2={
              <CustomKPI
                title={"Fire"}
                value={
                  (
                    (fireSummary.sum_claim_doc_pairs / totalFireDocs) *
                    100
                  ).toFixed(3) + "%"
                }
                text_below={
                  "(" +
                  fireSummary.sum_claim_doc_pairs +
                  " out of " +
                  totalFireDocs.toLocaleString() +
                  ")"
                }
                chip_color={"background.main"}
                text_color={orange[900]}
                value_color={orange[900]}
              />
            }
          />
        
        </Stack>  */}
        <DoubleChart
          title={"Similar Comparisons by Doc Code"}
          maxWidth={"100%"}
          minWidth={"100%"}
          stackDirection="column"
          chart1={
            <CustomBarChart
              title="Auto"
              sorted={true}
              xAxisLabelAngle={-45}
              chartData={rollupDocCodes(
                Object.entries(autoSummary.claim_doc_pairs_by_doc_code).map(
                  ([key, value]) => ({
                    docCode: key.split("|")[0] + " - " + key.split("|")[1], // X-axis key
                    count: value, // Y-axis value
                  })
                )
              )}
              dataKey_xaxis="docCode" // Key for X-axis
              dataKey_yaxis1="count" // Key for Y-axis
              color1={blue[900]}
              color2={blue[600]}
            />
          }
          chart2={
            <CustomBarChart
              title="Fire"
              sorted={true}
              xAxisLabelAngle={-45}
              chartData={rollupDocCodes(
                Object.entries(fireSummary.claim_doc_pairs_by_doc_code).map(
                  ([key, value]) => ({
                    docCode: key.split("|")[0] + " - " + key.split("|")[1], // X-axis key
                    count: value, // Y-axis value
                  })
                )
              )}
              dataKey_xaxis="docCode" // Key for X-axis
              dataKey_yaxis1="count" // Key for Y-axis
              color1={orange[900]}
              color2={blue[600]}
            />
          }
        />
        <DoubleChart
          title={"Similar Comparisons by Number of Pages"}
          maxWidth={"100%"}
          minWidth={"100%"}
          stackDirection="column"
          chart1={
            <CustomBarChart
              title="Auto"
              margin={{ top: 12, right: 10, left: 10, bottom: 1 }}
              chartData={Object.entries(
                autoSummary.claim_doc_pairs_by_num_pages
              ).map(([key, value]) => ({
                numPages: key, // X-axis key
                count: value, // Y-axis value
              }))}
              dataKey_xaxis="numPages" // Key for X-axis
              dataKey_yaxis1="count" // Key for Y-axis
              color1={blue[900]}
              color2={blue[600]}
            />
          }
          chart2={
            <CustomBarChart
              title="Fire"
              margin={{ top: 12, right: 10, left: 10, bottom: 1 }}
              chartData={Object.entries(
                fireSummary.claim_doc_pairs_by_num_pages
              ).map(([key, value]) => ({
                numPages: key, // X-axis key
                count: value, // Y-axis value
              }))}
              dataKey_xaxis="numPages" // Key for X-axis
              dataKey_yaxis1="count" // Key for Y-axis
              color1={orange[900]}
              color2={blue[600]}
            />
          }
        />
        <DoubleChart
          title={"Similar Comparisons by Skip Page"}
          maxWidth={"100%"}
          minWidth={"100%"}
          chart1={
            <CustomPieChart
              title="Auto"
              chartData={Object.entries(
                autoSummary.claim_doc_pairs_by_skip_page
              ).map(([key, value]) => ({
                name: key, // Slice label
                value: value, // Slice size
              }))}
              colors={[blue[900], blue[700], blue[500]]}
            />
          }
          chart2={
            <CustomPieChart
              title="Fire"
              chartData={Object.entries(
                fireSummary.claim_doc_pairs_by_skip_page
              ).map(([key, value]) => ({
                name: key, // Slice label
                value: value, // Slice size
              }))}
              colors={[orange[900], orange[700], orange[500]]}
            />
          }
        />
      </Stack>
  
    </Stack>
  );
}

export default SummaryDashboard;
